import { IDT } from '@gift/types/IDT';
import { reportError } from '../helpers/logging';

export function reportConfigurationErrors(options: IDT.Options) {

    const errors = [];

    errors.push(...validateContainers(options));
    errors.push(...validateEvents(options));

    if (errors.length) {
        reportError(
            'Invalid IDT configuration. Refer to the docs for details on how to '
            + 'correctly configure IDT in your site. Details:\n\n * '
            + errors.join('\n\n * '));
    }
}

function validateContainers(options: IDT.Options): string[] {

    if (!options.containers) {
        return [
            'No containers supplied. The IDT options must include a property named '
            + '"containers" which is set to an object that contains the containers for '
            + 'the IDT UI (properties "designer" and "preview").'
        ];
    }

    const errors: string[] = [];

    function formatError(name: string) {
        return `No valid "${name}" container supplied. The IDT options must include a `
            + `property "containers: { ${name}: ___ }", which must be set to an `
            + 'HTMLElement object (not a query selector). If the options do appear to '
            + 'specify a container, ensure the selector did not return null.';
    }

    for (const key of ['preview', 'designer'] as (keyof IDT.Containers)[]) {
        const container = options.containers[key];
        if (!container || !container.tagName) {
            errors.push(formatError(key));
        }
    }

    return errors;
}

function validateEvents(options: IDT.Options): string[] {

    if (!options.events) {
        return [
            'No event callbacks supplied. The IDT options must include a property named '
            + '"events" which is set to an object that contains the callbacks for IDT.'
        ];
    }

    const errors: string[] = [];

    function formatError(name: string) {
        return `No valid "${name}" callback supplied. The IDT options must include a `
            + `property "events: { ${name}: ___ }" which must be set to a function to `
            + 'handle the event.';
    }

    for (const key of ['order'] as (keyof IDT.Events)[]) {
        const callback = options.events[key];
        if (typeof callback !== 'function') {
            errors.push(formatError(key));
        }
    }

    return errors;
}
